import Vue from 'vue';
import VueRouter from 'vue-router';
import { isUserLoggedIn } from '@/auth/utils';
import store from '@/store';
import { checkHasRole, resolveRouteRoles } from '@core/utils/roleAccess';
import verticalMenu from '@/navigation/vertical';
import routes from './routes';

Vue.use(VueRouter);
Vue.prototype.$appReady = false;

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes
});

router.beforeEach(async (to, _, next) => {
  const isLoggedIn = isUserLoggedIn();
  const { user } = store.state.auth;

  // Public routes
  if (!isLoggedIn && to.meta && !to.meta.loggedInNotRequired) {
    store.commit('app/SET_APP_READY', true);
    return next({ name: 'auth-login' });
  }

  if (isLoggedIn && !user) {
    try {
      store.commit('app/SET_APP_READY', false);
      await store.dispatch('auth/me');
      store.commit('app/SET_APP_READY', true);
    } catch (err) {
      store.commit('app/SET_APP_READY', true);
      return next({ name: 'auth-login' });
    }
  }

  store.commit('app/SET_APP_READY', true);

  // Role-based access
  const requiredRoles = resolveRouteRoles(to.meta);
  if (requiredRoles && requiredRoles.length > 0 && !checkHasRole(requiredRoles)) {
    const findFirstAccess = items => {
      for (const item of items) {
        if (item.route && (!item.roles || item.roles.length === 0 || checkHasRole(item.roles))) {
          return item.route;
        }
        if (item.children) {
          const childRoute = findFirstAccess(item.children);
          if (childRoute) return childRoute;
        }
      }
      return null;
    };

    const firstRoute = findFirstAccess(verticalMenu);
    if (firstRoute && firstRoute !== to.name) {
      return next({ name: firstRoute });
    }

    // Fallback if nothing found (shouldn't happen in configured app) or to prevent loop
    if (to.name !== 'dashboard') {
      return next({ name: 'dashboard' });
    }
    return next(false);
  }

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg');
  if (appLoading) {
    appLoading.style.display = 'none';
  }
});

export default router;
